import React from "react";
import { Spin } from "antd";
import { Opportunity } from "../../helpers/shared-interfaces";
import StepContainer from "../../components/StepContainer";

interface Props {
  opportunity: Opportunity;
  finish: () => void;
  prev: () => void;
  setPercentage: (percentage: number) => void;
  getOpportunityDetails: () => void;
  getNextViewName: () => string | null;
  getPreviousViewName: () => string | null;
}

interface State {
  isLoading: boolean;
}

export default class OpportunitySummary extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount(): void {
    this.props.setPercentage(100);
    this.setState({ isLoading: false });
  }

  render(): JSX.Element {
    const { isLoading } = this.state;

    return (
      <Spin spinning={isLoading}>
        <StepContainer
          getNextViewName={this.props.getNextViewName}
          getPreviousViewName={this.props.getPreviousViewName}
          config={{
            prev: this.props.prev,
            finish: this.props.finish,
            showFinish: true,
            showPrev: true,
          }}
        >
          <div
            style={{
              marginBottom: "18px",
            }}
          >
            <h1>Opportunity Confirmation</h1>
            Are you sure you want to complete this opportunity?
          </div>
        </StepContainer>
      </Spin>
    );
  }
}
